import { Typography } from "@mui/material";

export const BillTotal = [
  {
    title: "",
    sorting: false,
    render: () => (
      <Typography varient="b" fontSize={"14px"}>
        Total
      </Typography>
    ),
  },
  {
    title: "",
    field: "totalBill",
    sorting: false,
    render: (rowData) =>
      rowData &&
      rowData.totalBill && (
        <Typography varient="p" fontSize={"14px"}>
          &#x20b9; {Math.trunc(rowData.totalBill)}
        </Typography>
      ),
  },

  {
    title: "",
    field: "totalParsed",
    sorting: false,
    render: (rowData) =>
      rowData &&
      rowData.totalParsed && (
        <Typography varient="p" fontSize={"14px"}>
          &#x20b9; {Math.trunc(rowData.totalParsed)}
        </Typography>
      ),
  },
  {
    title: "",
    field: "totalPML",
    sorting: false,
    render: (rowData) =>
      rowData &&
      rowData.totalPML && (
        <Typography varient="p" fontSize={"14px"}>
          &#x20b9; {Math.trunc(rowData.totalPML)}
        </Typography>
      ),
  },

  {
    title: "\u00A0",
    field: "totalSavings",
    sorting: false,
    render: (rowData) =>
      rowData &&
      rowData.totalSavings && (
        <Typography varient="p" fontSize={"14px"}>
          &#x20b9; {Math.trunc(rowData.totalSavings)}
        </Typography>
      ),
  }
];
